// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'http://localhost:4000',
  api: {
    auth: 'https://auth.diydev.useitweb.com',
    forms: 'https://forms.diydev.useitweb.com',
    mercadeo: 'https://mercadeo.diydev.useitweb.com',
    moments: 'https://momento.diydev.useitweb.com',
    sales: '',
    intelligence: 'https://intelligence.diydev.useitweb.com',
  },
  DIY_COOKIE_NAME: 'DYAUTH',
  DIY_COOKIE_DOMAIN: '.useitweb.com',
  DIY_COOKIE_TENANT: 'x-org-id',
  LANGUAGE_DEFAULT: 'es',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

